import {useProductContext} from 'contexts';
import {isDeviceSmall} from 'shared/helpers/DeviceSize';

// the room planner panel is 400px while the window stays wide, so a
// breakpoint alone never catches it
export const useCompactLayout = (): boolean => {
    const {isMiniBrowser} = useProductContext<{isMiniBrowser?: boolean}>();
    const isSmall = isDeviceSmall();

    return isMiniBrowser === true || isSmall;
};
